<app-report helpTemplate="dashboard-report"
            [paramsConfig]="['new_period']"
            [actionsConfig]="['comparison', 'filters']"
            [disableExports]="true"
            [disableDownloads]="true"
            (onFullscreen)="onFullscreen()"
            [iframe]="iframe$ | async"
            [enableDialogs]="true">
  <ng-container actions *ngIf="!(iframe$ | async)">
    <app-button icon="add"
                buttonType="mat-flat-button"
                [disabled]="!(initialized$ | async) || disableAddWidgetButton()"
                highlightId="dashboard-button-add-widget"
                (onClick)="onAddWidget()">{{ 'dashboard_report.add_widget' | translate }}</app-button>
    <app-button icon="dashboard"
                buttonType="mat-flat-button"
                [disabled]="!(initialized$ | async)"
                highlightId="dashboard-button-move-widgets"
                (onClick)="onMoveWidgets()">{{ 'dashboard_report.move_widgets' | translate }}</app-button>
  </ng-container>
  <div class="display-flex flex-column full-height background-color">
    <div class="flex-grow">
      <app-grid [dashboard]="dashboard$ | async"
                [readonly]="(iframe$ | async) || (publicMode$ | async)"></app-grid>
    </div>
    <div class="h-20"></div>
  </div>
</app-report>
<app-report-queue-loader></app-report-queue-loader>
